import { handleSeviceTypes } from "../../helpers"
import { publishRedirect } from "../../OnBoarding-V2/Events/utils.events"

const checkUserServiceWithMonetisation = ({ user, isSubscribed, isTveLoggedIn, isCheckout }) => {
    const serviceTypes = handleSeviceTypes();

    const shouldRedirect = () => {
        if (serviceTypes?.SVOD && serviceTypes?.TVE) {
            return user && isSubscribed && isTveLoggedIn;
        }
        if (serviceTypes?.SVOD && !serviceTypes?.TVE) {
            return user && isSubscribed;
        }
        if (!serviceTypes?.SVOD && serviceTypes?.TVE) {
            return user && isTveLoggedIn;
        }
        return false;
    };
    if (isCheckout) {
        if (shouldRedirect()) {
            publishRedirect('/');
        }
    }
};
export {checkUserServiceWithMonetisation}